/**
 * Datos de concursos del Colegio Bertolt Brecht
 * Incluye enlaces a bases, inscripción, contacto, etc.
 */

export const CONCURSOS_DATA = [
    {
        id: 1,
        title: 'I OLIMPIADA NACIONAL DE MATEMÁTICAS',
        slug: 'olimpiada-nacional-matematicas',
        startDate: '2026-07-11',
        registrationDeadline: '2026-07-10',
        category: 'Matemáticas',
        excerpt: 'Participa en la primera edición de nuestra Olimpiada Nacional de Matemáticas. Dirigido a estudiantes de 4° a 5° de secundaria.',
        content: `🧮 La Olimpiada Nacional de Matemáticas está dirigida a  estudiantes de los niveles Inicial, Primaria y Secundaria de instituciones educativas públicas y privadas del país.

🎯 El evento busca fortalecer el razonamiento lógico, el pensamiento crítico y las habilidades matemáticas mediante una competencia académica de alto nivel.

🏆 Reconocimientos:
• 🥇🥈🥉 Medallas para los primeros puestos
• 📱 Tablets para los mejores puntajes
• 🏆 Trofeos y gallardetes institucionales
• 📜 Diplomas de participación y mérito
• 🎮 Juegos recreativos y sorpresas para los participantes

💳 Métodos de pago:
(TITULAR: Roel Yaranga Sulca)
• 🏦 BCP - CUENTA SOLES: 22029971185024
• 🏦 BCP - CCI: 00222012997118502425
• 📲 Yape : 956 452 004

📌 Una vez realizado el pago, deberá adjuntar o enviar el comprobante correspondiente para validar su inscripción.

🚀 Invitamos a todos los estudiantes apasionados por las matemáticas a demostrar su talento y representar a su institución educativa en esta gran competencia nacional.`,
        image: '/assets/images/BERTOLT-MATH-2026.jpeg',
        imageAlt: 'Olimpiada de Matemáticas',
        organizer: 'Institución Educativa Privada "Bertolt Brecht"',
        featured: true,
        location: 'Jr. callao # 257 - Ayacucho',
        links: [
            { label: '📋 Bases del concurso', url: '/concurso-matemática-2026.pdf' },
            { label: '📝 Inscripción online', url: 'https://forms.gle/F1SW8C8HCeBwtwgZ8' },
            { label: '📞 Contacto', url: 'mailto:contacto@bertoltbrecht.edu.pe' }
        ]
    },
];

// Funciones auxiliares
export const getFeaturedConcursos = () => CONCURSOS_DATA.filter(c => c.featured);
export const getLatestConcursos = (limit = 3) => CONCURSOS_DATA.slice(0, limit);
export const getConcursoBySlug = (slug) => CONCURSOS_DATA.find(c => c.slug === slug);
export const getConcursosByCategory = (category) => CONCURSOS_DATA.filter(c => c.category === category);
export const formatConcursoDate = (dateString) => {
    if (!dateString) return '';

    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};